/**
 * SEMILLAS (E7-lite, 2026-08-23): lo que se coloca en el plano alimenta a los motores.
 *
 * Riego, Cámaras y Wi-Fi siguen calculando en su propio motor (cobertura, zonas,
 * DORI); lo que cambió es DÓNDE se captura: los aspersores, las cámaras y los puntos
 * de acceso se colocan en el plano de la casa, en el recinto que toca (jardín,
 * predio, cuarto), como cualquier otro objeto de la cotización. Al abrir el motor,
 * arranca con esos equipos ya puestos en vez de en blanco.
 *
 *   objetos[id] = { rubro: 'riego'|'camaras'|'wifi', tipo: 'producto', sku: <modelo>,
 *                   recinto, q, posiciones: [{x,y}] }
 *
 * El motor conserva su forma de dato (`aspersores[]`, `camaras[]`, `aps[]`); esta es la
 * traducción, y es de ida: lo que el motor corrija después vive en su partida.
 */

import { aspersorPorId } from './riego.js'

const idDe = (o, i) => `${o.id}-${i}`

/** Aspersores de riego como los crea `Jardin.jsx` al tocar. */
export function aspersoresDesdeObjetos(objetos = {}) {
  return Object.values(objetos).filter(o => o.rubro === 'riego' && o.posiciones?.length).flatMap(o => {
    const m = aspersorPorId(o.sku)
    return o.posiciones.map((p, i) => ({
      id: idDe(o, i), x: p.x, y: p.y, modelo: m.id,
      radio: m.radio, gasto: m.gasto, presion: m.presion, arco: 360, orientacion: 0
    }))
  })
}

/** Cámaras como las crea `Recinto.jsx` (rumbo 0: se orienta en el motor). */
export function camarasDesdeObjetos(objetos = {}) {
  return Object.values(objetos).filter(o => o.rubro === 'camaras' && o.posiciones?.length)
    .flatMap(o => o.posiciones.map((p, i) => ({ id: idDe(o, i), x: p.x, y: p.y, modelo: o.sku, rumbo: 0 })))
}

/** Puntos de acceso Wi-Fi, misma forma que las cámaras (sector de 360°). */
export function apsDesdeObjetos(objetos = {}) {
  return Object.values(objetos).filter(o => o.rubro === 'wifi' && o.posiciones?.length)
    .flatMap(o => o.posiciones.map((p, i) => ({ id: idDe(o, i), x: p.x, y: p.y, modelo: o.sku, rumbo: 0 })))
}

export const semillaDe = (rubro, objetos) =>
  rubro === 'riego' ? aspersoresDesdeObjetos(objetos)
  : rubro === 'camaras' ? camarasDesdeObjetos(objetos)
  : rubro === 'wifi' ? apsDesdeObjetos(objetos)
  : []
